// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const root = "OldRadioButton__root__xHtLU";
export const radioInput = "OldRadioButton__radioInput__1sWxV";
export const label = "OldRadioButton__label__xaEBv Checkbox__label__x07ar font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const mark = "OldRadioButton__mark__tAk-u Checkbox__mark__+r1s7";
export const checked = "OldRadioButton__checked__SGN7J Checkbox__input__x0nIS";